import axios from "axios";

const isLocal = window.location.host === "localhost:8080";

const HOST = isLocal
  ? `${process.env.VITE_APP_BACKEND_DEV}/api/v2`
  : `${window.location.protocol}//${window.location.hostname}/api/v2/`;

const headers = {
  Accept: "application/json",
};

if (isLocal || localStorage.getItem("token")) {
  console.log("insideBearer");
  headers[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
}

const AuthBackendV2 = axios.create({
  baseURL: HOST,
  withCredentials: true,
  headers,
});

export default AuthBackendV2;
